// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-game-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.about-game-section .about-game-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.about-game-section .about-game-wrap .heading-text {
  color: var(--black-1000);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.4;
  z-index: 1;
  position: relative;
  margin-bottom: 1.25rem;
}
.about-game-section .about-game-wrap .heading-text span {
  display: block;
}
.about-game-section .about-game-wrap .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.about-game-section .about-game-wrap .list-text .list-item {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  margin-left: 1.5rem;
}
.about-game-section .about-game-wrap .list-text .list-item.list-item-title {
  list-style-type: none;
  margin-left: 0;
}
@media screen and (max-width: 991.98px) {
  .about-game-section {
    padding: 2.5rem 0;
  }
  .about-game-section .about-game-wrap .heading-text {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  .about-game-section .about-game-wrap .para-text {
    font-size: 1rem;
  }
  .about-game-section .about-game-wrap .list-text .list-item {
    font-size: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .about-game-section {
    padding: 2rem 0;
  }
  .about-game-section .about-game-wrap .heading-text {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  .about-game-section .about-game-wrap .para-text {
    font-size: 0.875rem;
  }
  .about-game-section .about-game-wrap .list-text .list-item {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 639.98px) {
  .about-game-section {
    padding: 2rem 0;
  }
  .about-game-section .about-game-wrap .heading-text {
    margin-bottom: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutGameSection/AboutGameStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;AACN;AACM;EACE,cAAA;AACR;AAGI;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AADN;AAMM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAMQ;EACE,qBAAA;EACA,cAAA;AAJV;AAUE;EA/CF;IAgDI,iBAAA;EAPF;EAUI;IACE,iBAAA;IACA,mBAAA;EARN;EAWI;IACE,eAAA;EATN;EAaM;IACE,eAAA;EAXR;AACF;AAgBE;EApEF;IAqEI,eAAA;EAbF;EAgBI;IACE,kBAAA;IACA,mBAAA;EAdN;EAiBI;IACE,mBAAA;EAfN;EAmBM;IACE,mBAAA;EAjBR;AACF;AAsBE;EAzFF;IA0FI,eAAA;EAnBF;EAsBI;IACE,sBAAA;EApBN;AACF","sourcesContent":[".about-game-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .about-game-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .heading-text {\n      color: var(--black-1000);\n      font-size: 2.25rem;\n      font-weight: 700;\n      line-height: 1.4;\n      z-index: 1;\n      position: relative;\n      margin-bottom: 1.25rem;\n  \n      span {\n        display: block;\n      }\n    }\n\n    .para-text {\n      color: var(--black-1000);\n      font-size: 1.5rem;\n      font-weight: 400;\n      line-height: 1.4;\n    }\n    \n\n    .list-text {\n      .list-item {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n        margin-left: 1.5rem;\n\n        &.list-item-title {\n          list-style-type: none;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n    \n    .about-game-wrap {  \n      .heading-text {\n        font-size: 1.5rem;\n        margin-bottom: 1rem;\n      }\n\n      .para-text {\n        font-size: 1rem;\n      }\n\n      .list-text {\n        .list-item {\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    \n    .about-game-wrap {  \n      .heading-text {\n        font-size: 1.25rem;\n        margin-bottom: 1rem;\n      }\n\n      .para-text {\n        font-size: 0.875rem;\n      }\n\n      .list-text {\n        .list-item {\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n    \n    .about-game-wrap {  \n      .heading-text {\n        margin-bottom: 0.75rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
